module.exports = __webpack_public_path__ + "static/media/assessment-end-screen-footer.6d340509.png";